import { formatMileage, normaliseMileage } from '@/features/vehiclesearch/utils/mileage';

export function mileageBelowRecordedWarning(raw: string, recorded: number | null): string | null {
    const digits = normaliseMileage(raw);
    if (recorded === null || !/^\d+$/.test(digits) || Number(digits) >= recorded) return null;
    return `This is lower than the last recorded ${formatMileage(recorded)} miles. Check it before you submit.`;
}
